var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"fm-main"},[_c('div',{staticClass:"fm-page fm-page--narrow"},[_vm._m(0),_c('div',{staticClass:"fm-page-desc"},[_vm._v("Your identity, credentials, and active sessions.")]),_c('user-card')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fm-page-head"},[_c('div',{staticClass:"fm-page-title"},[_vm._v("Account")])])
}]

export { render, staticRenderFns }